import React from "react";
import "../styles/Home.css";
import Header from "./common/Header";
import Footer from "./common/Footer";

const FaqPage = (props: any) => {
  return (
    <>
      <Header
        userId={props.userId}
        onNavigateToLanding={props.onNavigateToLanding}
        personalData={props.personalData}
        onHandleNavigateToProfileScreen={props.onHandleNavigateToProfileScreen}
        onLogout={props.onLogout}
      />
      <div className="faq_page_section main-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">Frequently Asked Questions</div>
            </div>
            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">What is FikrFree? </div>
                <div className="faq_text">
                  FikrFree is an insurance and healthcare marketplace app offering a variety of insurance products and healthcare services, including e-pharmacy and doctor consultations. You can activate, deactivate, and manage your policies conveniently through the app.
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  Where can I download the FikrFree app?
                </div>
                <div className="faq_text">
                  You can download the FikrFree app from the Google Play Store and the Apple App Store.
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">Does FikrFree have a website?</div>
                <div className="faq_text">
                  Yes, you can visit our website at {" "}
                  <a href="https://fikrfree.com.pk/home" target="_blank">
                    fikrfree.com.pk
                  </a>{" "}
                  or{" "}
                  <a href="https://jazz.com.pk/mobile-apps/fikrfree" target="_blank">
                    Jazz FikrFree
                  </a>{" "}
                  for more information about our services and products.
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  Which types of insurance are available on FikrFree?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">
                    FikrFree offers a wide range of insurance products,
                    including:
                  </div>
                  <ul>
                    <li>Health Insurance</li>
                    <li>Life Insurance</li>
                    <li>Accidental Insurance</li>
                    <li>OPD and IPD Plans</li>
                    <li>Cancer Takaful Plan</li>
                    <li>Women Plan</li>
                    <li>Handset Insurance</li>
                    <li>Car Insurance</li>
                    <li>Bike Insurance</li>
                    <li>Home Content Insurance</li>
                    <li>Crop Insurance</li>
                    <li>Educational Document Insurance</li>
                    <li>Pet and Vet Insurance</li>
                    <li>Dental and Vision Insurance</li>
                    <li>Car Key Insurance</li>
                    <li>Home Registry Insurance</li>
                    <li>Car Document Insurance</li>
                    <li>Income Insurance</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  Who are the partners on FikrFree?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">Our trusted partners include:</div>
                  <ul>
                    <li>BIMA</li>
                    <li>EFU</li>
                    <li>Waada</li>
                    <li>Webdoc</li>
                    <li>MedIQ</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q Num_list */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  How can I activate an insurance policy?
                </div>
                <div className="faq_list_content num_list">
                  <div className="faq_text">To activate a policy:</div>
                  <ul>
                    <li>Download and open the FikrFree app.</li>
                    <li>Log in using your phone number.</li>
                    <li>Enter your details for login.</li>
                    <li>Select your desired policy type from the homepage.</li>
                    <li>Choose an insurance partner and a price plan.</li>
                    <li>Select your preferred payment method.</li>
                    <li>Enter the OTP to verify.</li>
                    <li>Receive a confirmation SMS.</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q Num_list */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  Can I deactivate a policy?
                </div>
                <div className="faq_list_content num_list">
                  <div className="faq_text">
                    Yes, you can deactivate your policy. Follow these steps:
                  </div>
                  <ul>
                    <li>Open the FikrFree app.</li>
                    <li>Go to the "Policy" section.</li>
                    <li>
                      Click the "Deactivate" button for the desired policy.
                    </li>
                    <li>Receive a confirmation SMS.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  How can I sync my existing policy with the app?
                </div>
                <div className="faq_text">
                  If you are an existing policyholder, your policy details will
                  be automatically synced once you download and log in to the
                  FikrFree app.
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What are the payment methods available?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">
                    You can pay for your insurance using:
                  </div>
                  <ul>
                    <li>Prepaid mobile balance (daily payments)</li>
                    <li>JazzCash wallet (monthly payments)</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q Num_list */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">How do I make a claim?</div>
                <div className="faq_list_content num_list">
                  <div className="faq_text">To make a claim:</div>
                  <ul>
                    <li>Open the FikrFree app..</li>
                    <li>Go to the "Claim" section.</li>
                    <li>Click "Make a Claim."</li>
                    <li>
                      Select the policy for which you want to file a claim.
                    </li>
                    <li>
                      Check the required documents under the dropdown menu.
                    </li>
                    <li>Upload the required documents.</li>
                    <li>Provide account information for claim distribution.</li>
                    <li>Click "Submit."</li>
                    <li>
                      Track your claim status in the "Claim" section of the
                      dashboard.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  How do I contact customer support?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">
                    For insurance-related claims, you can:
                  </div>
                  <ul>
                    <li>
                      Use the customer support feature in the FikrFree app.
                    </li>
                    <li>Call the helplines of our partners:</li>
                  </ul>
                  <ul className="circle_list">
                    <li>
                      <b>BIMA:</b> 042 111 71 9878
                    </li>
                    <li>
                      <b>EFU:</b> 042 3333 0333 or 042 111 333 033
                    </li>
                    <li>
                      {" "}
                      <b>Webdoc:</b> 051-8848801
                    </li>
                    <li>
                      <b>Waada:</b> 021-111-992-232
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What healthcare services are available on FikrFree? FikrFree offers:
                </div>
                <div className="faq_list_content">
                  {/* <div className="faq_text">FikrFree offers:</div> */}
                  <ul>
                    <li>
                      Doctor consultations (General Physicians and Specialists in 30+ categories)
                    </li>
                    <li>
                      	E-pharmacy for prescription and over-the-counter medicines
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q Num_list */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  How do I book a doctor’s appointment?
                </div>
                <div className="faq_list_content num_list">
                  {/* <div className="faq_text">To make a claim:</div> */}
                  <ul>
                    <li>Open the FikrFree app</li>
                    <li>Click on "Talk to a Doctor."</li>
                    <li>Select a category (GP or Specialist).</li>
                    <li>Choose a doctor.</li>
                    <li>Select the date and time.</li>
                    <li>Proceed to payment.</li>
                    <li>Confirm the booking.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What are the consultation charges?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>GP consultations range between PKR 500-1,500.</li>
                    <li>
                      Specialist consultations range between PKR 1,000-3,000.
                    </li>
                    <li>
                      MedIQ subscribers enjoy free GP consultations and 50% off
                      on specialist consultations.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q Num_list */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  How does the e-pharmacy service work?
                </div>
                <div className="faq_list_content num_list">
                  <div className="faq_text">To buy medicines:</div>
                  <ul>
                    <li>Open the FikrFree app.</li>
                    <li>Click on "Pharmacy."</li>
                    <li>Select a category and the desired medicine.</li>
                    <li>Enter your address.</li>
                    <li>Proceed to payment.</li>
                    <li>Track your order under the "Orders" tab.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What discounts are available for MedIQ subscribers?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">MedIQ subscribers receive:</div>
                  <ul>
                    <li>10% discount on medicines</li>
                    <li>Free home delivery</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  How can I stay updated with FikrFree?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">
                    Follow us on social media for the latest updates:
                  </div>
                  <ul>
                    <li>
                      <b>Facebook:</b>fikrfreeofficialpk
                    </li>
                    <li>
                      <b>Instagram:</b> fikrfreeofficialpk
                    </li>
                    <li>
                      <b>X (Twitter):</b> fikrfreepk
                    </li>
                    <li>
                      <b>YouTube:</b> fikrfreeofficialpk
                    </li>
                    <li>
                      <b>Threads:</b> fikrfreeofficialpk
                    </li>
                    <li>
                      <b>Snapchat:</b> fikrfreepk
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  What if I have pricing-related concerns?
                </div>
                <div className="faq_text">
                  For pricing details, visit the FikrFree app or website at{" "}
                  <a href="https://fikrfree.com.pk/home" target="_blank">
                    fikrfree.com.pk
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  In which cities does FikrFree deliver medicines?
                </div>
                <div className="faq_text">
                  FikrFree delivers medicines across 40+ cities in Pakistan.
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  What is the cancellation or refund policy?
                </div>
                <div className="faq_text">
                  Refer to the FikrFree app for detailed terms and conditions
                  regarding cancellations and refunds.
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  Are all insurance products conventional or Takaful-based?
                </div>
                <div className="faq_text">
                  FikrFree offers both conventional and Takaful insurance
                  products to cater to diverse needs.
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  How can I provide feedback or suggestions?
                </div>
                <div className="faq_text">
                  You can provide feedback through the "Contact Us" section in
                  the app or via email at info@fikrfree.com.pk
                </div>
              </div>
            </div>

            {/* Document-Req-For-Claim */}
            <div className="col-lg-12">
              <div className="faq_content">
                <div className="faq_heading">
                  What documents are required for a claim?
                </div>
                <div className="faq_text">
                  A: The required documents vary depending on the type of insurance. Below is a categorized breakdown of the documents needed:
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a health insurance claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>CNIC (Computerized National Identity Card).</li>
                    <li>
                      Final hospital invoice or discharge report stating the
                      admission and discharge dates.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a life insurance claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>CNIC copies of both the claimant and the deceased.</li>
                    <li>Hospital death certificate and all medical records.</li>
                    <li>NADRA/Union Council death certificate</li>
                    <li>
                      Any additional documents requested by the Takaful Operator
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a disability claim in
                  Accidental Insurance?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>Claimant’s Statement Form.</li>
                    <li>Attending Physician’s Report.</li>
                    <li>
                      Police and medico-legal report (for hospitalization due to
                      an accident or violence).
                    </li>
                    <li>CNIC copy of the claimant</li>
                    <li>Any additional documents deemed necessary</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a death claim under
                  accidental insurance?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>All documents required for disability claims</li>
                    <li>CNIC copies of both the claimant and the deceased</li>
                    <li>Hospital death certificate and all medical records</li>
                    <li>NADRA/Union Council death certificate</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a personal accident claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>Claimant’s Statement Form.</li>
                    <li>Hospital death certificate and all medical records</li>
                    <li>NADRA/Union Council death certificate</li>
                    <li>CNIC copies of both the claimant and the deceased.</li>
                    <li>
                      FIR/Police report and post-mortem report (if applicable).
                    </li>
                    <li>Any additional documents deemed necessary</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a handset theft claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>FIR</li>
                    <li>CNIC number linked to the handset registration</li>
                    <li>Blocked IMEI report from PTA</li>
                    <li>
                      Incident statement (phone usage history and details)
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a screen damage claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>CNIC number linked to the handset registration</li>
                    <li>Video showing the screen damage and IMEI number</li>
                    <li>Phone submission at a Waada dealership or collection by a representative</li>
                    <li>Picture or proof of phone damage</li>

                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a car insurance claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>CNIC copies (both sides)</li>
                    <li>Registration documents of the car.</li>
                    <li>Driving license of the insured.</li>
                    <li>Repair bills or cash memos.</li>
                    <li>Police report (for theft, robbery, or burglary)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a bike insurance claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>CNIC copies (both sides)</li>
                    <li>Registration documents of the bike</li>
                    <li>Driving license of the insured.</li>
                    <li>Repair bills or cash memos.</li>
                    <li>Police report (for theft, robbery, or burglary)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a crop insurance claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>CNIC copies (both sides).</li>
                    <li>
                      Pictures of the damaged crop with the insured in the frame
                    </li>
                    <li>
                      Certificates from the Meteorological Department, NDMA, or
                      the local Agricultural Department
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a home content insurance
                  claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>CNIC copies (both sides).</li>
                    <li>Cell number of the insured.</li>
                    <li>Police report (for theft, robbery, or burglary).</li>
                    <li>Damaged items handed over to the company as salvage</li>
                    <li>Purchase invoices for damaged or stolen items</li>
                    <li>Any other necessary documents as required</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a cancer takaful plan
                  claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>
                      Detailed medical reports from the attending physician or
                      oncologist.
                    </li>
                    <li>Pathology and diagnostic reports.</li>
                    <li>Claimant Statement Form.</li>
                    <li>CNIC copy of the claimant.</li>
                    <li>
                      Any additional documents requested by the Takaful Operator
                      .{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a women plan
                  claim?
                </div>
                <div className="faq_list_content">
                  <ul>
                    <li>Diagnostic Report / Doctor's Consultation Report</li>
                    <li>Duly filled Medical Claim Form</li>
                    <li>CNIC of the Member</li>
                    <li>Medical Bills .</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a Car Key Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">To submit a car key insurance claim, please provide:</div>
                  <ul>
                    <li>Police report (in case of loss)</li>
                    <li>Receipts or proof of ownership</li>
                    <li>CNIC copy</li>
                    <li>Photo of the damaged key (in case of damage)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for an Educational Document Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">You will need the following documents:</div>
                  <ul>
                    <li>FIR copy</li>
                    <li>CNIC of the policyholder</li>
                    <li>Copies of lost or damaged educational documents</li>
                    <li>Reissuance challans and bills</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a Home Registry Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">Please submit:</div>
                  <ul>
                    <li>FIR copy</li>
                    <li>Scanned copy of the original home registry</li>
                    <li>CNIC copy of the insured</li>

                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a Women Health Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">Required documents include:</div>
                  <ul>
                    <li>Hospital admission and discharge slips</li>
                    <li>Doctor's prescription or medical history note</li>
                    <li>Relevant medical reports, if available</li>
                    <li>All related bills</li>
                    <li>CNIC (front and back)</li>
                    <li>Proof of income loss (e.g., salary slip), if claiming income compensation</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a CNIC Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">To claim under CNIC insurance, provide:</div>
                  <ul>
                    <li>CNIC copy (if available)</li>
                    <li>FIR copy</li>
                    <li>NADRA duplicate processing receipt and bills</li>

                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a Passport Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">Submit the following documents:</div>
                  <ul>
                    <li>FIR copy</li>
                    <li>CNIC copy and damaged passport copy (if available)</li>
                    <li>Reissuance documents</li>
                    <li>Proof of reissuance expenses (e.g., challan forms, receipts, bank slips)</li>
                    <li>A written statement explaining how the loss occurred</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a Car Document Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">You will need:</div>
                  <ul>
                    <li>CNIC copies (front and back)</li>
                    <li>Police report or FIR</li>
                    <li>Vehicle registration details</li>
                    <li>Proof of token tax payment</li>

                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a Dental and Vision Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">Please submit the following:</div>
                  <ul>
                    <li>CNIC copies (front and back)</li>
                    <li>Prescription from a dentist or eye specialist</li>
                    <li>Details of investigation and treatment</li>
                    <li>Medical invoices/bills and receipts (must be prescribed)</li>
                    <li>Lab reports (must be prescribed)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* List-Q */}
            <div className="col-lg-12">
              <div className="faq_content f_list">
                <div className="faq_heading">
                  What documents are required for a Pet and Vet Insurance claim?
                </div>
                <div className="faq_list_content">
                  <div className="faq_text">To file a claim, you need:</div>
                  <ul>
                    <li>CNIC copies of the policyholder (front and back)</li>
                    <li>Vet's prescription with treatment details</li>
                    <li>Medical receipts and invoices</li>
                    <li>Lab reports, if any</li>
                    <li>Proof of ownership (e.g., vaccination card, registration, or a photo with the pet)</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

    </>
  );
};

export default FaqPage;
